// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__fUf_A","title":"Images90_title__gD39u","images":"Images90_images__3dvK-"};